import * as actionTypes from './actionTypes'

import businessService from 'services/businessService'


export const fetchingBusinessFromUser = () =>{
  return dispatch =>{
    businessService
    .getBusinessFromUser()
    .then(business=>{
      dispatch(fetchingBusinessSuccess(business))
    })
    .catch(err => {
      console.log(err)
    })

  }
}


const fetchingBusinessSuccess = (business) =>{
  return{
    type: actionTypes.FETCHING_BUSINESS_SUCCESS,
    business : business
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Business.js